export class Tag {
  constructor ({
    id = null,
    name = null,
    color = null,
    category,
    efz = null
  } = {}) {
    this.id = id
    this.name = name
    this.color = color
    this.category = category
    // the emission factor zone is that's a geotag
    this.efz = efz
  }

  get isGeoTag () {
    return !!this.efz
  }

  get isUntagged () {
    return this.name === Tag.UNTAGGED_LABEL
  }

  isEqual (tag) {
    if (this.id && tag.id) {
      return this.id === tag.id
    } else {
      return (
        this.name.trim() === tag.name.trim() &&
        this.color === tag.color &&
        this.category === tag.category &&
        this.efz === tag.efz
      )
    }
  }

  getCategory (categories) {
    let results = categories.filter((category) => this.category === category.id)
    if (results.length === 1) {
      return results[0]
    } else {
      return null
    }
  }

  toDatabase () {
    return {
      id: this.id,
      name: this.name,
      efz: this.efz
    }
  }

  static get UNTAGGED_LABEL () {
    return 'untagged'
  }

  static createFromObj (data) {
    if (typeof data === 'string') {
      return new Tag({ name: data })
    } else {
      return new Tag({
        id: data.id,
        name: data.name,
        color: data.color,
        category: data.category,
        efz: data.efz
      })
    }
  }
}

export default class TagCategory {
  constructor ({
    id = null,
    name = '',
    description = '',
    color = null,
    tags = [],
    isGeoTag = false
  } = {}) {
    this.id = id
    this.name = name
    this.description = description
    this.color = color
    this.tags = tags.map((obj) => Tag.createFromObj(obj))
    this.isGeoTag = isGeoTag
  }

  isEqual (category) {
    if (this.id && category.id) {
      return this.id === category.id
    } else {
      return this.name === category.name && this.color === category.color
    }
  }

  toDatabase () {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      color: this.color,
      tags: this.tags.map((obj) => obj.toDatabase()),
      is_geo_tag: this.isGeoTag
    }
  }

  removeTag (tag) {
    let index = this.tags.findIndex((obj) => obj.isEqual(tag))
    this.tags.splice(index, 1)
  }

  addTag (tag) {
    if (tag instanceof Tag) {
      this.tags.push(tag)
      return tag
    } else {
      let t = Tag.createFromObj(tag)
      this.tags.push(t)
      return t
    }
  }

  static createFromObj (data) {
    return new TagCategory({
      id: data.id,
      name: data.name,
      description: data.description,
      color: data.color,
      tags: data.tags,
      isGeoTag: data.is_geo_tag
    })
  }
}
